import { Injectable } from '@angular/core';
import { SearchGroup, Status, translateCommonErrorStatus } from '@core/data';
import { AdvancedReportCompilerService } from '@core/data/api/reports/advanced-report-compiler.service';
import { IndexComponentData } from '@core/data/types/advanced-report';
import { Characteristic, Index } from '@library';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';

export interface ReportIndexFormStateModel {
    //? NEEDED FOR COMPILATIONS
    reportKey: string;
    ownerOrgKey: string;

    data: IndexComponentData;
    status: Status;

    characteristics: SearchGroup<Characteristic>[];
    indexes: SearchGroup<Index>[];
}

const DEFAULTS: ReportIndexFormStateModel = {
    reportKey: null,
    ownerOrgKey: null,

    data: null,
    status: Status.UNINITIALIZED,

    characteristics: [],
    indexes: [],
}

export class InitReportIndexForm {
    static readonly type = "[ReportIndexForm] Init";
    constructor(public reportKey: string, public ownerOrgKey: string, public data: IndexComponentData) {}
}

export class LoadIndexFormOptions {
    static readonly type = "[ReportIndexForm] Load";
    constructor() {}
}

@State<ReportIndexFormStateModel>({
    name: 'advanced_report_index_from',
    defaults: DEFAULTS,
})
@Injectable()
export class ReportIndexFormState {

    @Selector()
    static characteristics(state: ReportIndexFormStateModel) {
        return state.characteristics;
    }

    @Selector()
    static indexes(state: ReportIndexFormStateModel) {
        return state.indexes;
    }

    constructor(
        private _compilerService: AdvancedReportCompilerService,
    ) {}


    @Action(InitReportIndexForm)
    initReportIndexForm(ctx: StateContext<ReportIndexFormStateModel>, action: InitReportIndexForm) {
        ctx.setState({
            ...DEFAULTS,
            reportKey: action.reportKey,
            ownerOrgKey: action.ownerOrgKey,
            data: action.data,
            status: Status.LOADING,
        });

        ctx.dispatch(LoadIndexFormOptions);
    }

    @Action(LoadIndexFormOptions)
    loadIndexFormOptions(ctx: StateContext<ReportIndexFormStateModel>, action: LoadIndexFormOptions) {
        const state = ctx.getState();

        ctx.patchState({
            status: Status.LOADING
        });

        return this._compilerService.indexOptions(state.reportKey, state.ownerOrgKey)
            .pipe(
                tap(
                    result => {
                        ctx.patchState({
                            status: Status.OK,
                            characteristics: result?.characteristics || [],
                            indexes: result?.indexes || [],
                        });
                    },
                    error => {
                        ctx.patchState({
                            status: translateCommonErrorStatus(error),
                            characteristics: [],
                            indexes: [],
                        });
                    }
                )
            )
    }
}